const INITIAL_STATE = {
    data: null
}

const EmpresasReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'empresas': {

            return {
                ...state,
                data: action.payload.empresas,
                config: action.payload.config
            }
        }
        default: {
            return state
        }
    }
}

export default EmpresasReducer
